import {
  db_value_1_data,
  dimensiondata_1_regiok_es_varmegyek_group_dimension_1_2_row,
  dimensiondata_2_tetelek_group_dimension_1_2_first_column_expanded,
  kilowatt_ora_value_2_data,
  quarter_row_expanded,
  year_row_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const elektromobilitasForgConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/ElektromobilitasForg',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1', 'value_2'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      quarter_row_expanded,
      ...dimensiondata_1_regiok_es_varmegyek_group_dimension_1_2_row,
      ...dimensiondata_2_tetelek_group_dimension_1_2_first_column_expanded,
      db_value_1_data,
      kilowatt_ora_value_2_data,
      order_1,
      order_2
    ],
  },
};
